import { onCleanup, onMount, createSignal, Show } from "solid-js";
import p5 from "p5";

const Loading = (props) => {
  // const [containerRef, setContainerRef] = createSignal(null);
  // let sketch = null;

  // onMount(() => {
  //   const initializeSketch = () => {
  //     const container = containerRef();
  //     if (container && container.offsetWidth > 0 && container.offsetHeight > 0) {
  //       sketch = new p5((p) => {
  //         let radius = 125;
  //         const minRadius = 120;
  //         const maxRadius = 130;
  //         const duration = 1000;

  //         const frequency = 9;
  //         const minAmplitude = -3;
  //         const maxAmplitude = 3;
  //         const w = container.offsetWidth;
  //         const h = container.offsetHeight;
  //         let wavePhase = 0;

  //         p.setup = () => {
  //           p.createCanvas(w, h);
  //           p.frameRate(30);
  //         };

  //         p.draw = () => {
  //           p.clear();
  //           p.background(0, 0, 0, 0);
  //           p.translate(p.width / 2, p.height / 2);

  //           const phase = (p.millis() % duration) / duration;
  //           radius =
  //             minRadius +
  //             (maxRadius - minRadius) *
  //               (Math.sin(phase * Math.PI * 2) * 0.5 + 0.5);

  //           const wavePhaseOffset = (p.millis() % duration) / duration;
  //           const amplitude =
  //             minAmplitude +
  //             (maxAmplitude - minAmplitude) *
  //               (Math.sin(wavePhaseOffset * Math.PI * 2) * 0.5 + 0.5);

  //           p.strokeWeight(1.5);
  //           p.stroke(255, 255, 255);
  //           p.noFill();

  //           p.beginShape();
  //           const totalPoints = 200;

  //           for (let i = 0; i <= totalPoints; i++) {
  //             const angle = p.map(i, 0, totalPoints, 0, p.TWO_PI);

  //             const x = radius * p.cos(angle);
  //             const y = radius * p.sin(angle);
  //             const displacement =
  //               amplitude * p.sin(frequency * angle + wavePhase);
  //             const normalX = p.cos(angle);
  //             const normalY = p.sin(angle);
  //             const finalX = x + normalX * displacement;
  //             const finalY = y + normalY * displacement;

  //             p.vertex(finalX, finalY);
  //           }
  //           p.endShape(p.CLOSE);

  //           wavePhase -= 0.09;
  //         };
  //       }, container);
  //     } else {
  //       setTimeout(initializeSketch, 10);
  //     }
  //   };

  //   initializeSketch();
  // });

  // onCleanup(() => {
  //   if (sketch) sketch.remove();
  // });

  return (
    <Show when={props.show}>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          "z-index": 9999,
          background: "rgba(0, 0, 0, 0.6)",
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
        }}>
        {/* <div
          ref={setContainerRef}
          style={{
            width: "50vmin",
            height: "50vmin",
          }}
        /> */}
      </div>
    </Show>
  );
};

export default Loading;
